// Images for featured services
import proImg from '../assets/services/agric_project_card.webp';
import riceImg from '../assets/services/rice_pro.webp';
import researchImg from '../assets/services/research.webp';

const FeaturedService = [
  {
    id: 'agric projects',
    featureImg: proImg,
    featureHeadline: 'agricultural project development and management',
  },
  {
    id: 'rice processing',
    featureImg: riceImg,
    featureHeadline: 'rice cultivation and processing',
  },
  {
    id: 'agricultural research',
    featureImg: researchImg,
    featureHeadline: 'agricultural research & development and consultancy',
  },
];

export default FeaturedService;
